export const initialState = {
  codeId: '',
  result: '',
  error: '',
  code: '',
  hasMoreAttempts: true,
  timer: 0,
};
